import { ADD_COMMENT, DELETE_COMMENT, LOAD_COMMENTS, SET_COMMENTS_LOADING, UPDATE_COMMENT } from './actions';

const defaultState = {
  comments: null,
};

export default function(state = defaultState, action) {
  switch (action.type) {

  case LOAD_COMMENTS:
    return { comments: action.comments };

  case ADD_COMMENT:
    return {
      ...state,
      comments: [
        ...state.comments,
        action.comment,
      ]
    };

  case UPDATE_COMMENT:
    return {
      ...state,
      comments: state.comments.map(comment => comment.id === action.comment.id ? action.comment : comment),
    };

  case DELETE_COMMENT:
    return {
      ...state,
      comments: state.comments.filter(comment => comment.id !== action.comment.id),
    };

  case SET_COMMENTS_LOADING:
    return {
      ...state,
      loading: action.loading,
    };
    
  default:
    return state;
  }
}
